/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsUnderUtilizedAzureAdvisorResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsUnderUtilizedAzureAdvisorResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsUnderUtilizedAzureAdvisorResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsUnderUtilizedAzureAdvisorResource>): RecommendationForFinopsUnderUtilizedAzureAdvisorResource {
        let obj = Object.assign(new RecommendationForFinopsUnderUtilizedAzureAdvisorResource(), model);
        RecommendationForFinopsUnderUtilizedAzureAdvisorResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsUnderUtilizedAzureAdvisorResource>): RecommendationForFinopsUnderUtilizedAzureAdvisorResource {
        if (!model) return null;
        return RecommendationForFinopsUnderUtilizedAzureAdvisorResource.newInstance(<RecommendationForFinopsUnderUtilizedAzureAdvisorResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsUnderUtilizedAzureAdvisorResource) {
        if (!obj) return;

        models.RecommendationForFinopsUnderUtilizedAzureAdvisorResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsUnderUtilizedAzureAdvisorResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsUnderUtilizedAzureAdvisorResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
